import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addHttps',
  standalone: true,
})
export class AddHttpsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    if (!/^https?:\/\//i.test(value)) {
      return 'https://' + value;
    }
    return value;
  }
}
